import { observable, action, runInAction } from 'mobx';
import Cookies from 'js-cookie';

import Service from '@service/index';
import moSkin from './skin';

const moStore = observable({
  isLoading: false,
  loginModal: false,
  isContactModal: false,
  isAddModal: false,
  count: 0,
  isMarketQueryModal: false,
});

type IKey = 'isLoading';
const toggleValue = action((key: IKey, value: boolean) => {
  moStore[key] = value;
});

const toggleLoading = action((value: boolean) => {
  moStore.isLoading = value;
});

const toggleLogin = action((value: boolean) => {
  moStore.loginModal = value;
});

const toggleConcatModal = action((value: boolean) => {
  moStore.isContactModal = value;
});

const toggleAddModal = action((value: boolean) => {
  moStore.isAddModal = value;
});

// 获取剩余查询次数
const requestChance = action(async () => {
  const token = Cookies.get('access_token') || '';
  const res: any = await Service.getChances({ access_token: token });
  runInAction(() => {
    moStore.count = res.result || 0;
  });
});

// 联系客服
const contactService = () => {
  const { partner } = moSkin;
  if (partner === 'smartsalary') {
    const $btn = document.getElementById('nb_invite_ok');
    if ($btn) {
      $btn.click();
    }
  } else {
    toggleConcatModal(true);
  }
};

const toggleModalQueryModal = action((value: boolean) => {
  moStore.isMarketQueryModal = value;
});

export default moStore;
export {
  toggleValue, toggleLogin, toggleLoading,
  toggleConcatModal, toggleAddModal, contactService,
  requestChance, toggleModalQueryModal,
};
